import { Select } from '@flex-design-system/fx';
import { getUndefinedValueController } from '@flex-private-packages/recruiting-common/base';
import type { ReactNode } from 'react';

import SelectTriggerFieldBox from './SelectTriggerFieldBox';

const UNDEFINED_VALUE = '__UNDEFINED_VALUE__';
const { withUndefinedValue, getValueWithoutUndefined } =
  getUndefinedValueController(UNDEFINED_VALUE);

interface Props {
  isLoading?: boolean;
  disabled?: boolean;
  itemList: string[];
  emptyValueLabel: ReactNode;
  value?: string;
  onValueChange: (newValue?: string) => void;
  optionItemLabelTransfer?: (value: string) => string;
}

function SelectWithEmptyValue({
  isLoading,
  disabled,
  itemList,
  emptyValueLabel,
  value,
  onValueChange,
  optionItemLabelTransfer = item => item,
}: Props) {
  const handleValueChange = (newValue: string) => {
    onValueChange(getValueWithoutUndefined(newValue));
  };

  return (
    <Select value={withUndefinedValue(value)} onValueChange={handleValueChange}>
      <Select.Trigger asChild disabled={isLoading || disabled}>
        <SelectTriggerFieldBox isLoading={isLoading} disabled={disabled}>
          {value ? optionItemLabelTransfer(value) : emptyValueLabel}
        </SelectTriggerFieldBox>
      </Select.Trigger>
      <Select.Content>
        <Select.Option value={UNDEFINED_VALUE}>
          <Select.OptionTitle>{emptyValueLabel}</Select.OptionTitle>
        </Select.Option>
        {itemList.map(item => (
          <Select.Option key={item} value={item}>
            <Select.OptionTitle>
              {optionItemLabelTransfer(item)}
            </Select.OptionTitle>
          </Select.Option>
        ))}
      </Select.Content>
    </Select>
  );
}

export default SelectWithEmptyValue;
